module.exports = __webpack_public_path__ + "static/media/5e_website_logo_diamond_huawei.a2a3a5b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/5e_website_logo_diamond_huawei.jpg
// module id = 89
// module chunks = 0